import { formatCurrency } from "@ashirbad/js-core";
import {
  CheckCircle,
  LibraryAddCheck,
  LocalShipping,
  Redeem,
  ShoppingCart,
} from "@mui/icons-material";
import {
  Avatar,
  Button,
  MenuItem,
  Select,
  Step,
  StepLabel,
  Stepper,
} from "@mui/material";
import { db, useIsMounted } from "hooks";
import {
  useOrdersData,
  useProducts,
  useSuppliers,
  useUsers,
} from "hooks/useDataFetch";
import moment from "moment";
import React, { useEffect } from "react";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";

const OrderDetails = () => {
  const [orderDetails, setOrderDetails] = useState({});
  const [userData, setUserData] = useState({});
  const [activeStep, setActiveStep] = useState(0);

  const { id } = useParams();

  const navigate = useNavigate();

  const orders = useOrdersData();
  const users = useUsers();
  const products = useProducts();
  const suppliers = useSuppliers();

  const isMounted = useIsMounted();
  // console.log(orderDetails);

  useEffect(() => {
    if (isMounted.current) {
      if (!orders?.data) return;

      let data = orders?.data?.find((item) => {
        return item?.id === id;
      });

      setOrderDetails(data || {});
    }
  }, [isMounted, orders?.data, id]);
  useEffect(() => {
    if (isMounted.current) {
      if (!orderDetails) return;
      if (!users?.data) return;

      let data = users?.data?.find((item) => {
        return item?.id === orderDetails?.userId;
      });
      setUserData(data || {});
    }
  }, [isMounted, orderDetails, users?.data]);

  useEffect(() => {
    if (isMounted.current) {
      if (!orderDetails) return;
      if (orderDetails?.status === "pending") {
        setActiveStep(0);
      } else if (orderDetails?.status === "processing") {
        setActiveStep(1);
      } else if (orderDetails?.status === "packed") {
        setActiveStep(2);
      } else if (orderDetails?.status === "shipped") {
        setActiveStep(3);
      } else {
        setActiveStep(4);
      }
    }
  }, [isMounted, orderDetails]);

  // console.log(orders?.data);
  // console.log(orderDetails);
  // console.log(userData);

  ///stipper

  const steps = [
    {
      label: "Order Placed",
      description: "Order has been placed",
      status: "pending",
      icon: () => {
        return (
          <ShoppingCart
            sx={{
              backgroundColor: `${activeStep >= 0 ? "#dd547e" : "#c3c3c3"}`,
              color: "white",
              height: "5rem",
              width: "5rem",
              padding: "1rem",
              borderRadius: "1rem",
              margin: "auto",
              position: "relative",
              transform: "translate(0px, -30%)",
              zIndex: "1",
            }}
          />
        );
      },
    },
    {
      label: "Order Confirmed",
      description: "Order has been confirmed",
      status: "processing",
      icon: () => {
        return (
          <Redeem
            sx={{
              backgroundColor: `${activeStep >= 1 ? "#dd547e" : "#c3c3c3"}`,
              color: "white",
              height: "5rem",
              width: "5rem",
              padding: "1rem",
              borderRadius: "1rem",
              margin: "auto",
              position: "relative",
              transform: "translate(0px, -30%)",
              zIndex: "1",
            }}
          />
        );
      },
    },
    {
      label: "Order Packed",
      description: "Order has been packed",
      status: "processing",
      icon: () => {
        return (
          <LibraryAddCheck
            sx={{
              backgroundColor: `${activeStep >= 2 ? "#dd547e" : "#c3c3c3"}`,
              color: "white",
              height: "5rem",
              width: "5rem",
              padding: "1rem",
              borderRadius: "1rem",
              margin: "auto",
              position: "relative",
              transform: "translate(0px, -30%)",
              zIndex: "1",
            }}
          />
        );
      },
    },
    {
      label: "Order Shipped",
      description: "Order has been shipped",
      status: "shipped",
      icon: () => {
        return (
          <LocalShipping
            sx={{
              backgroundColor: `${activeStep >= 3 ? "#dd547e" : "#c3c3c3"}`,
              color: "white",
              height: "5rem",
              width: "5rem",
              padding: "1rem",
              borderRadius: "1rem",
              margin: "auto",
              position: "relative",
              transform: "translate(0px, -30%)",
              zIndex: "1",
            }}
          />
        );
      },
    },
    {
      label: "Order Delivered",
      description: "Order has been delivered",
      status: "delivered",
      icon: () => {
        return (
          <CheckCircle
            sx={{
              backgroundColor: `${activeStep >= 4 ? "#dd547e" : "#c3c3c3"}`,
              color: "white",
              height: "5rem",
              width: "5rem",
              padding: "1rem",
              borderRadius: "1rem",
              margin: "auto",
              position: "relative",
              transform: "translate(0px, -30%)",
              zIndex: "1",
            }}
          />
        );
      },
    },
  ];

  const sendMail = async () => {
    try {
      // console.log("running");
      const response = await fetch(
        "https://water-sy-api.herokuapp.com/invoice",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            content: {
              invoiceId: orderDetails?.id,
              name:
                orderDetails?.address?.firstName ||
                "" + " " + orderDetails?.address?.lastName ||
                "",
              address:
                orderDetails?.address?.address +
                  " " +
                  orderDetails?.address?.landMark ||
                "" + ", " + orderDetails?.address?.city ||
                "" + ", " + orderDetails?.address?.country ||
                "" + ", " + orderDetails?.address?.postalCode ||
                "",
              country: orderDetails?.address?.country || "",
              phone: userData?.phoneNumber || "",
              date: orderDetails?.createdAt || "",
              totalPrice: orderDetails?.totalPrice || "",
              product: orderDetails?.products?.map((item) => {
                return {
                  name: item.productName,
                  price: item.price,
                  quantity: item.orderedQty,
                };
              }),
            },
            to: userData?.email,
            subject: "Invoice",
          }),
        }
      );
      const data = await response.json();

      console.log(data);

      // console.log(data);
    } catch (error) {
      // console.log(error);
    }
  };

  const handleNext = (activeStatus) => {
    try {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to change the status of this order",
        icon: "warning",
        showCancelButton: true,
      }).then(async (result) => {
        // console.log(result);
        // console.log(activeStep);
        // console.log(activeStatus);
        if (!result.isConfirmed) {
          return;
        }

        setActiveStep(activeStatus);

        if (activeStatus === 1) {
          // console.log(activeStep);
          await db.updateDb(
            `orders/${orderDetails?.userId}/${orderDetails?.id}`,
            {
              status: "processing",
              orderMessage: "Order has been confirmed",
            }
          );
          Swal.fire({
            title: "Order Confirmed",
            text: "Order status has been changed",
            icon: "success",
          });
          return;
        } else if (activeStatus === 2) {
          // console.log(activeStep);
          await db.updateDb(
            `orders/${orderDetails?.userId}/${orderDetails?.id}`,
            {
              status: "packed",
              orderMessage: "Order has been packed",
            }
          );
          Swal.fire({
            title: "Order Packed",
            text: "Order status has been changed",
            icon: "success",
          });
          return;
        } else if (activeStatus === 3) {
          // console.log(activeStep);
          await db.updateDb(
            `orders/${orderDetails?.userId}/${orderDetails?.id}`,
            {
              status: "shipped",
              orderMessage: "Order has been shipped",
            }
          );
          Swal.fire({
            title: "Order Shipped",
            text: "Order status has been changed",
            icon: "success",
          });
          return;
        } else if (activeStatus === 4) {
          await db.updateDb(
            `orders/${orderDetails?.userId}/${orderDetails?.id}`,
            {
              status: "delivered",
              orderMessage: "Order has been delivered",
              deliveredAt: new Date().toISOString(),
              delivered: true,
              paymentStatus: "paid",
            }
          );
          Swal.fire({
            title: "Order Delivered",
            text: "Order status has been changed",
            icon: "success",
          });
          // await db.updateDb()

          let data = products?.data?.filter((item) => {
            return orderDetails?.products?.some((product) => {
              return item?.id === product?.productId;
            });
          });
          let supplierData = suppliers?.data?.filter((item) => {
            return orderDetails?.products?.some((product) => {
              return item?.id === product?.supplierId;
            });
          });

          for (let i = 0; i < orderDetails?.products?.length; i++) {
            let product = data?.find((item) => {
              return item?.id === orderDetails?.products[i].productId;
            });
            let supplier = supplierData?.find((item) => {
              return item?.id === orderDetails?.products[i].supplierId;
            });
            await db.updateDb(
              `products/${orderDetails?.products[i].productId}`,
              {
                totalSold: product?.totalSold + 1,
                quantity: product?.quantity - 1,
              }
            );

            await db.updateDb(
              `suppliers/${orderDetails?.products[i]?.supplierId}`,
              {
                totalSales: supplier?.totalSales + 1,
              }
            );
          }
          sendMail();

          return;
        }
        return;
      });
    } catch (error) {
      console.log(error);
      Swal.fire({
        title: "Error Refresh And Try Again",
        text: "Something went wrong",
        icon: "error",
      });
    }
  };

  return (
    <section className="dashboard-order-details">
      <div className="order-details-tracking">
        <div className="order-details-tracking-title">
          <h3> Tracking Order No - {orderDetails?.id} </h3>
        </div>
        <div className="w-100 order-progress">
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((item, index) => {
              const stepProps = {};
              const labelProps = {};

              return (
                <Step key={item.label} {...stepProps}>
                  <StepLabel StepIconComponent={item.icon} {...labelProps}>
                    {item.label}
                  </StepLabel>
                </Step>
              );
            })}
          </Stepper>
          <div className="order-change-status w-100 gap-2 ">
            {orderDetails?.delivered && (
              <Button
                sx={{
                  backgroundColor: "#df2c2c !important",
                  ":hover": {
                    backgroundColor: "#df2c2c !important",
                  },
                }}
                onClick={() => {
                  navigate(`/admin/invoices/${orderDetails?.id}`);
                }}
              >
                Download Invoice
              </Button>
            )}
            <Select
              value={activeStep}
              sx={{
                width: "15rem",
              }}
              onChange={(e) => {
                handleNext(e.target.value);
              }}
            >
              <MenuItem
                sx={{
                  display: activeStep >= 0 && "none",
                }}
                value={0}
              >
                Order Placed
              </MenuItem>
              <MenuItem
                sx={{
                  display: activeStep >= 1 && "none",
                }}
                value={1}
              >
                Confirm Order
              </MenuItem>
              <MenuItem
                sx={{
                  display: activeStep >= 2 && "none",
                }}
                value={2}
              >
                Order Packed
              </MenuItem>
              <MenuItem
                sx={{
                  display: activeStep >= 3 && "none",
                }}
                value={3}
              >
                Order Shipped
              </MenuItem>
              <MenuItem
                sx={{
                  display: activeStep >= 4 && "none",
                }}
                value={4}
              >
                Order Delivered
              </MenuItem>
            </Select>
          </div>
        </div>
      </div>
      <div className="dashboard-order-title">
        <h3>Order Details</h3>
        <span className="flex-column gap-1">Order ID : #{id}</span>
      </div>
      <div className="flex-row gap-2 align-items-center order-details-content-box flex-wrap">
        <div className="address-details-card">
          <div className="address-details-card-title">
            <h4>Customer</h4>
          </div>
          <div className="flex-column gap-1   address-details-card-container">
            <span>{userData?.displayName}</span>
            <span>{userData?.email}</span>
            <span>{userData?.phoneNumber}</span>
          </div>
        </div>
        <div className="address-details-card">
          <div className="address-details-card-title">
            <h4>Shipped To</h4>
          </div>
          <div className="flex-column justify-content-between   address-details-card-container">
            <span>
              {" "}
              {orderDetails?.address?.firstName +
                " " +
                orderDetails?.address?.lastName}{" "}
              ({orderDetails?.address?.addressType}){" "}
            </span>
            <span>{orderDetails?.address?.address} </span>
            <span>
              {" "}
              {orderDetails?.address?.city} {orderDetails?.address?.postalCode}{" "}
            </span>
            <span>{orderDetails?.address?.landMark}</span>
            <span>{orderDetails?.address?.country}</span>
          </div>
        </div>
        <div className="address-details-card">
          <div className="address-details-card-title">
            <h4>Payment Method</h4>
          </div>
          <div className="flex-column gap-1   address-details-card-container">
            <span>{orderDetails?.paymentMode}</span>
            <span>{orderDetails?.paymentStatus}</span>
            {orderDetails?.paymentStatus === "paid" && (
              <span> Pay On - {orderDetails?.paymentDate}</span>
            )}
            {orderDetails?.paymentId && (
              <span> Payment Id - {orderDetails?.paymentId}</span>
            )}
          </div>
        </div>
        <div className="address-details-card">
          <div className="address-details-card-title">
            <h4>Order Date</h4>
          </div>
          <div className="flex-column gap-1   address-details-card-container">
            <span>
              {" "}
              Order On - {moment(orderDetails?.createdAt).format("LLL")}{" "}
            </span>
            <span> Delivery Date - {orderDetails?.deliveryDate} </span>
          </div>
        </div>
      </div>
      <div className="w-100">
        <div className="dashboard-order-details-title w-100 flex-row justify-content-center align-items-center">
          <h3>Product Summery</h3>
        </div>
        <table className="order-details-table w-100">
          <thead className="w-100 order-table-head">
            <tr className="flex-row align-items-center  gap-2 w-100">
              <th>#</th>
              <th>Image</th>
              <th>Product</th>
              <th>Supplier</th>
              <th>Quantity/Uint</th>
              <th>Price</th>
              <th>Subtotal</th>
            </tr>
          </thead>
          <tbody className="order-details-table-body">
            {orderDetails?.products?.map((item, index) => {
              return (
                <tr
                  className="flex-row align-items-center  gap-2 w-100"
                  key={index}
                >
                  <td>{index + 1}</td>
                  <td>
                    <Avatar
                      src={item?.productImg}
                      sx={{
                        width: "6rem",
                        height: "7rem",
                        borderRadius: "10px",
                      }}
                    />
                  </td>
                  <td>{item?.productName}</td>
                  <td>{item?.supplierName}</td>
                  <td>{item?.orderedQty}</td>
                  <td>{formatCurrency(item?.price, "SAR")}</td>
                  <td>
                    {formatCurrency(item?.price * item?.orderedQty, "SAR")}
                  </td>
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            <tr className="flex-row align-items-center order-table-foot  gap-2 w-100">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>Total</td>
              <td>
                {formatCurrency(
                  orderDetails?.products?.reduce(
                    (acc, item) => acc + item?.price * item?.orderedQty,
                    0
                  ),
                  "SAR"
                )}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </section>
  );
};

export default OrderDetails;
